import * as React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COUNTRY } from '@mango-engineering/maknet-client-sdk/lib/shop/types';
import { getThemeBasedIconColor } from '../../config/theme/getThemeBasedIconColor';

interface AddIconProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
  country: COUNTRY;
}

const TitleIconHolder = styled(Box)<{ bgColor: string }>(({ theme, bgColor }) => ({
  padding: theme.spacing(0.5),
  backgroundColor: bgColor,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: theme.shape.borderRadius,
  width: theme.spacing(2),
  height: theme.spacing(2),
}));

export const ThumbsUpIcon: React.FC<AddIconProps> = ({
  color = '#FFF',
  size = 40,
  country,
  ...props
}) => {
  const colors = getThemeBasedIconColor(country);

  return (
    <TitleIconHolder bgColor={colors.primary}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M3.467 13.667H.333v-6h1.334l1.8 6ZM12.333 5h-4V2.333a2 2 0 0 0-2-2h-.666V3L3.733 5.417A3.347 3.347 0 0 0 3 7.507v.826L4.4 13h5.558a2.666 2.666 0 0 0 2.587-2.02l1.081-4.323A1.331 1.331 0 0 0 12.333 5Z"
          fill={color}
        />
      </svg>
    </TitleIconHolder>
  );
};
